<template>
  <div class="reporting-page">
    <PageBanner
      title="Reporting"
      subtext="Select a report type to generate and review reporting for Purapura Whetu services."
    />

    <div class="outcome-tab-container">
      <q-select
        v-model="selectedReport"
        :options="reportOptions"
        class="report-select"
        outlined
        emit-value
        map-options
        label="Report type"
      />

      <div class="report-tab-panel">
        <component
          :is="activeReportComponent"
          v-bind="activeReportProps"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { hasFeature } from "@/services/util/featureHandler";
import PageBanner from "@/components/ClientComponents/DashboardComponents/PageBanner.vue";
import ElderReportPanel from "./reporting/ElderReportPanel.vue";
import KpiReportPanel from "./reporting/KpiReportPanel.vue";
import NarrativeReportPanel from "./reporting/NarrativeReportPanel.vue";
import TeAraReportPanel from "./reporting/TeAraReportPanel.vue";
import TeTumuWaioraSupportReportPanel from "./reporting/TeTumuWaioraSupportReportPanel.vue";
import GamblingReportPanel from "./reporting/GamblingReportPanel.vue";
import KoTatouReportPanel from "./reporting/KoTatouReportPanel.vue";
import TeamLeadReport from './TeamLeadReport.vue';

const REPORT_OPTIONS = Object.freeze([
  { label: "KPI Reporting", value: "kpi" },
  { label: "Narrative Reporting", value: "narrative" },
  { label: "Elder Reporting", value: "elder" },
  { label: "Te Tumu Waiora Support", value: "ttw-support" },
  { label: "Te Ara Tuhono Reporting", value: "te-ara", feature: "teAraTuhono" },
  { label: "Gambling Support Reporting", value: "gambling" },
  { label: "Ko Tātou Reporting", value: "ko-tatou", feature: "koTatouReporting" },
  { label: "Team Lead Reporting", value: "team-lead" }
]);

export default {
  components: {
    ElderReportPanel,
    KpiReportPanel,
    NarrativeReportPanel,
    TeAraReportPanel,
    TeTumuWaioraSupportReportPanel,
    GamblingReportPanel,
    KoTatouReportPanel,
    TeamLeadReport,
    PageBanner
  },

  data() {
    return {
      selectedReport: "narrative",
      quarterOptions: [
        { label: "Q1 (Jul - Sept)", value: 1 },
        { label: "Q2 (Oct - Dec)", value: 2 },
        { label: "Q3 (Jan - Mar)", value: 3 },
        { label: "Q4 (Apr - Jun)", value: 4 }
      ],
      teAraQuarterOptions: [
        { label: "Q1 (Mar - May)", value: 1 },
        { label: "Q2 (Jun - Aug)", value: 2 },
        { label: "Q3 (Sept - Nov)", value: 3 },
        { label: "Q4 (Dec - Feb)", value: 4 }
      ],
      financialYears: [
        { label: "2023-2024", value: 2023 },
        { label: "2024-2025", value: 2024 },
        { label: "2025-2026", value: 2025 },
        { label: "2026-2027", value: 2026 }
      ]
    }
  },

  computed: {
    reportOptions() {
      return REPORT_OPTIONS.filter((option) => !option.feature || hasFeature(option.feature));
    },

    activeReportComponent() {
      const componentsByReport = {
        kpi: KpiReportPanel,
        narrative: NarrativeReportPanel,
        elder: ElderReportPanel,
        "ttw-support": TeTumuWaioraSupportReportPanel,
        "te-ara": TeAraReportPanel,
        gambling: GamblingReportPanel,
        "ko-tatou": KoTatouReportPanel,
        "team-lead": TeamLeadReport
      };

      return componentsByReport[this.selectedReport];
    },

    activeReportProps() {
      if (!["kpi", "elder", "te-ara", "ko-tatou"].includes(this.selectedReport)) {
        return {};
      }

      return {
        financialYears: this.financialYears,
        quarterOptions: this.selectedReport === "te-ara"
          ? this.teAraQuarterOptions
          : this.quarterOptions
      };
    }
  }
}
</script>

<style lang="css" scoped>
.reporting-page {
  width: 100%;
}

.outcome-tab-container {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: flex-start;
  padding: 3rem;
  width: 100%;
  box-sizing: border-box;
}

.report-select,
.report-tab-panel {
  width: 100%;
  max-width: 800px;
}

.report-select :deep(.q-field__control) {
  background: white;
  border-radius: 10px;
}

.report-tab-panel {
  margin-top: 20px;
  background-color: #e4e8e1;
}
</style>
